import text from './resources/locale/en.json';

class VenueHours {
    $onInit() {
        this.text = text;
    }
}

export default VenueHours;
